import type { StorageTraceRef } from "../../api/admin-content";
import { t } from "../../i18n";

export function sourceTypeLabel(type: StorageTraceRef["ref_type"]): string {
  return labelFor(`storage_detail.source_${type}`, type);
}

export function storageStatusLabel(status: string): string {
  return labelFor(`storage_detail.status_${status}`, status);
}

export function labelFor(key: string, fallback: string): string {
  const translated = t(key);
  return translated === key ? fallback : translated;
}

export function shortId(id: string): string {
  return id.length <= 8 ? id : id.slice(0, 8);
}

export function formatBytes(bytes: number): string {
  if (bytes === 0) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  const i = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1,
  );
  const value = bytes / 1024 ** i;
  return `${value.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

export function formatDate(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
}
